import * as React from 'react';
import * as styles from './styles.css';

import img1Src from './assets/img1.svg';
import img2Src from './assets/img2.svg';

import { ArticleHeading1, ArticleHeading2, Button, UIHeading3, UIHeading4, UIText1, UIText2 } from '@cian/ui-kit';
import { IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';
import { ConditionalWrapper } from '@cian/conditional-component';

export interface IDreamItemProps {
  isDesktop: boolean;
  onButtonClick: () => void;
}

export const DreamItem: React.FC<IDreamItemProps> = ({ isDesktop, onButtonClick }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <ConditionalWrapper if={isDesktop} ThenComponent={ArticleHeading1} ElseComponent={ArticleHeading2}>
          Продать, чтобы купить другую
        </ConditionalWrapper>
        <UIText1>Добавьте денег и вложитесь в новый, более привлекательный объект</UIText1>
      </div>

      <div className={styles['wrapper']}>
        <div>
          <ConditionalWrapper if={isDesktop} ThenComponent={UIHeading3} ElseComponent={UIHeading4}>
            Плюсы нового объекта
          </ConditionalWrapper>

          <ul className={styles['dream-wrapper-details']}>
            <li>
              <ConditionalWrapper if={isDesktop} ThenComponent={UIText1} ElseComponent={UIText2}>
                Более выгодный для сдачи район
              </ConditionalWrapper>
            </li>
            <li>
              <ConditionalWrapper if={isDesktop} ThenComponent={UIText1} ElseComponent={UIText2}>
                Современная планировка
              </ConditionalWrapper>
            </li>
            <li>
              <ConditionalWrapper if={isDesktop} ThenComponent={UIText1} ElseComponent={UIText2}>
                Популярный ЖК среди покупателей
              </ConditionalWrapper>
            </li>
          </ul>
        </div>

        <div className={styles['dream-wrapper-img-1']}>
          <img src={img1Src} />
        </div>

        <div className={styles['dream-wrapper-img-2']}>
          <img src={img2Src} />
        </div>
      </div>

      <ul className={styles['additional']}>
        <li>
          <IconFunctionalSuccess16 color="primary_100" />

          <UIText1>Квартира в новостройке вырастет в цене, и её можно будет дороже продать</UIText1>
        </li>

        <li>
          <IconFunctionalSuccess16 color="primary_100" />

          <UIText1>Доходность от аренды будет выше, чем у существующего объекта</UIText1>
        </li>

        <li>
          <IconFunctionalSuccess16 color="primary_100" />

          <UIText1>Всё ещё надёжное вложение в недвижимость</UIText1>
        </li>
      </ul>

      <Button size="L" onClick={onButtonClick} fullWidth={!isDesktop}>
        Посмотреть варианты
      </Button>
    </div>
  );
};
